/**
 * i18n translations setup
 *
 * the working in v2 is kept same as in v1 -
 * not sure why we have different language logic for login and forgot routes
 *
 * UPDATE:
 * - we store the lanuage on change in localstorage as "login_language"
 * - we use this instead of getting from session
 *
 * --------------------------------------------------------------------------------
 *
 * - we want the user to have the same language as it was in there previous session
 * - on changes of language, we store it in localstorage
 * - and only use it when session language is not found
 *
 * - we have residual session in localstorage
 * - we read the language from the session if available
 * - if no session, we default to de
 * - if the route is login or forgot_password
 * - we read the language from localstorage if available
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import packageJson from "../package.json";

import { IS_LOCALHOST } from "@/config/Constants";
import { TRANSLATION_BASE_URL } from "@/services/ServiceConstants";

let currentLanguage = "de";

const loginLanguage = localStorage.getItem("login_language") || "";
if (loginLanguage === "en" || loginLanguage === "de") {
  currentLanguage = loginLanguage;
}
const loc = TRANSLATION_BASE_URL;
const translationVersionString = `?v=${packageJson.version}${IS_LOCALHOST ? `&location=${window.location.pathname}` : ""}`;

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: currentLanguage,
    fallbackLng: "en",
    cleanCode: false,
    debug: false,
    load: "currentOnly",
    backend: {
      loadPath: loc + "v1/{{lng}}/translation.json" + translationVersionString,
    },
    interpolation: {
      escapeValue: false,
      skipOnVariables: false,
    },
  });

/**
 * attach the event trigger after init is done
 * won't work if added before
 */
const updateLangAttribute = () => {
  document.body.setAttribute("lang", i18n.language);
};
i18n.on("languageChanged", updateLangAttribute);

export default i18n;
